module.exports = __webpack_public_path__ + "static/media/Histograma.12ba5222.svg";